import { DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { ToCurrencyPipe } from './to-currency.pipe';

@NgModule({
  providers: [DecimalPipe],
  declarations: [ToCurrencyPipe],
  exports: [ToCurrencyPipe],
})
export class ToCurrencyModule {}
